import React from 'react';
import { Card } from 'primereact/card';

const DashboardStats = ({ stats }) => {
  return (
    <Card className="mb-4" style={{ margin: "0", padding: "0" }}>
      <div className="p-1">
        <h2 className="text-xl font-bold mb-1" style={{ margin: "0" }}>Dashboard Summary</h2>
        <div className="grid grid-cols-3 gap-5" style={{ margin: "0" }}>
          <div>
            <p className="font-semibold">Total Posts: {stats.totalPosts}</p>
          </div>
          <div>
            <p className="font-semibold">Unread Posts: {stats.unreadPosts}</p>
          </div>
          <div>
            <p className="font-semibold">Starred Posts: {stats.starredPosts}</p>
          </div>
          <div>
            <p className="font-semibold">Skipped Posts: {stats.skippedPosts}</p>
          </div>
          {stats.lastCrawledTime && (
            <div className="col-span-3">
              <p className="font-semibold">Last Crawled: {stats.lastCrawledTime}</p>
            </div>
          )}
          {stats.lastAnalyzedTime && (
            <div className="col-span-3">
              <p className="font-semibold">Last Analyzed: {stats.lastAnalyzedTime}</p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default DashboardStats;
